import { render } from "./StockClient.vue?vue&type=template&id=2855b0c4&scoped=true"
import script from "./StockClient.vue?vue&type=script&lang=js"
export * from "./StockClient.vue?vue&type=script&lang=js"

import "./StockClient.vue?vue&type=style&index=0&id=2855b0c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2855b0c4"]])

export default __exports__